<script setup>
import { usePage } from "@inertiajs/inertia-vue3";
import StarRating from "vue-star-rating";
import { reactive, computed, watch, ref } from "vue";

const emit = defineEmits([
  'update:modelValue',
  'submit'
])

const props = defineProps({
  rentableProduct: Object
})

const validReview = ref( false )

const themeColor = computed(() => usePage().props.value.theme_color);

const review = reactive({
  rating: 1,
  summary: '',
  rentable_id: props.rentableProduct.rentable.data.id
})

watch(review, (review) => {
  validReview.value = review.summary.length >= 10;

  emit('update:modelValue', review)
})

function nextRentableProduct() {
  emit('submit')
}

function submitReview() {
  if(validReview) {
    emit('submit')
  }
}

</script>

<template>
  <div class="mx-auto max-w-5xl py-16 px-4">
    <div class="bg-white">
      <div class="mx-auto py-16 px-4 sm:py-24 sm:px-6">
        <!-- Product -->
        <div>
          <!-- Product image -->
          <div class="lg:row-end-1 lg:col-span-4">
            <div class="overflow-hidden">
              <img :src="rentableProduct.rentable.data.image" alt="" class="object-center object-contain h-48 w-96 mx-auto" />
            </div>
          </div>

          <!-- Product details -->
          <div class="max-w-2xl mx-auto mt-14 sm:mt-16">
            <div class="flex flex-col-reverse">
              <div class="mt-4 text-center">
                <h1 class="text-2xl font-bold tracking-tight text-gray-900 sm:tracking-tight sm:text-3xl">
                  {{ rentableProduct.rentable.data.name }}
                </h1>

                <div class="mt-14">
                  <h3 class="sr-only">Reviews</h3>
                  <div class="flex items-center">
                    <star-rating
                      v-model:rating="review.rating"
                      star-size="25"
                      active-color="#facc15"
                      inline="false"
                      padding="3"
                      glow="0"
                      class="mx-auto"
                      text-class="inline-block text-80 h-9 pt-2"
                      :show-rating="false"
                    ></star-rating>
                  </div>
                </div>

              </div>
            </div>

            <div class="mt-10">
              <label for="comment" class="block text-sm font-medium text-gray-700">Omschrijf uw ervaring met het product</label>
              <div class="mt-1">
                <textarea v-model="review.summary" rows="4" name="comment" id="comment" maxlength="512" class="shadow-sm focus:ring-primary focus:border-primary block w-full sm:text-sm border-gray-300 rounded-md" />
              </div>
              <div v-if="!validReview" class="text-red-500 text-xs mt-1"> De review moet minimaal 10 letters bevatten.</div>
            </div>

            <div class="mt-10 grid grid-cols-1 gap-x-6 gap-y-4 sm:grid-cols-2">
              <button type="button"
                      @click="nextRentableProduct()"
                      class="w-full rounded-md items-center px-2.5 py-1.5 border border-gray-300 justify-center text-base font-medium rounded text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary">
                Overslaan
              </button>
              <button type="button"
                      :disabled="!validReview"
                      @click="submitReview()"
                      class="w-full bg-primary border border-transparent rounded-md py-3 px-8 flex items-center justify-center text-base font-medium text-white hover:bg-primary focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-primary">
                Volgende
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style>
/** These styles override the primary color and it's pseudo elements **/
.bg-primary {
  background-color: v-bind('themeColor') !important;
}

.text-primary {
  color: v-bind('themeColor') !important;
}

.text-primary:hover {
  color: v-bind('themeColor') !important;
}

.hover\:text-primary:hover {
  color: v-bind('themeColor') !important;
}

.focus\:ring-primary:focus {
  --tw-ring-color: v-bind('themeColor') !important;
}

.border-primary {
  border-color: v-bind('themeColor') !important;
}

.focus\:border-primary:focus {
  border-color: v-bind('themeColor') !important;
}
</style>
